import { RefObject, useEffect } from 'react';
import { useMemoizedFn, useThrottleFn } from 'ahooks';
import DataTypeUtils from '@gp/utils/DataTypeUtils';

/**
 * 监听window的resize事件，处理echarts resize
 * chartInstance echart实例
 */
export default function useChartResize(
  chartInstance: RefObject<IEChartInstanceRefObject>,
) {
  const { run: handleResize } = useThrottleFn(
    () => {
      setTimeout(() => {
        if (
          chartInstance?.current?.instance &&
          DataTypeUtils.isFunction(chartInstance.current.instance.resize)
        ) {
          chartInstance.current.instance.resize();
        }
      });
    },
    {
      // 等待时间，单位为毫秒
      wait: 600,
      // 是否在延迟开始前调用函数
      leading: true,
      // 是否在延迟开始后调用函数
      trailing: true,
    },
  );

  const handleResizeMemoized = useMemoizedFn(handleResize);

  useEffect(() => {
    window.addEventListener('resize', handleResizeMemoized, false);

    return () => {
      window.removeEventListener('resize', handleResizeMemoized);
    };
  }, [handleResizeMemoized]);
}
